import React, { useRef, ChangeEvent, useEffect, useState } from 'react';
import OSS from 'ali-oss';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { getToken } from '../../api/pile-apply';
import Toast from '@xpeng/rc-toast';
import FullLoading from '../../components/full-loading';
import 'react-photo-view/dist/react-photo-view.css';
import './index.less';
export interface FileDto {
  fileName?: string;
  fileOssPath?: string;
  url?: string;
}

interface UpdateImgProps {
  values: FileDto[];
  onChange: (urls: FileDto[]) => any;
}

export default function UpdateImg (props: UpdateImgProps) {
  const { values, onChange } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const inputEl = useRef<HTMLInputElement>(null);

  const getOssClient = (file: any) => {
    return new Promise((resolve, reject) => {
      let client: object = {};
      // 没缓存则请求并生成oss
      getToken({ pathType: 3, fileName: file.name })
        .then((result: any) => {
          const { code, msg, data } = result;

          if (![200, 0].includes(code)) {
            console.log('服务器开小差:' + msg);
            return;
          }
          const ossData = data || {};
          client = new OSS({
            accessKeyId: ossData.accessKeyId,
            accessKeySecret: ossData.accessKeySecret,
            stsToken: ossData.stsToken,
            region: ossData.region,
            bucket: ossData.bucket
          });
          const clientTemp = {
            domain: data.domain,
            pathPrefix: data.pathPrefix,
            useHttpForAccessLink: data.useHttpForAccessLink
          };
          const obj = Object.assign(client, clientTemp);

          resolve(obj);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  };
  const ossUploadFile = async (option: any) => {
    return getOssClient(option).then((client: any) => {
      const file = option;
      const suffix = file.name.substr(file.name.lastIndexOf('.'));
      const fileName = 'file' + new Date().getTime() + suffix;
      const clientInfo = client.multipartUpload(
        client.pathPrefix + '/' + fileName,
        file
      );
      return clientInfo.then((res: any) => {
        const dataTemp = {
          uploadInfo: res,
          domain: client.domain,
          useHttpForAccessLink: client.useHttpForAccessLink,
          filePath: client.pathPrefix,
          fileName: fileName
        };
        const data = Object.assign({}, dataTemp);

        return data;
      });
    });
  };

  const beforeUploadImgTypeLimit = (file: File | File[]): boolean => {
    if (Array.isArray(file)) {
      file = file[0];
    }
    let fileExtension = file.name
      .substring(file.name.lastIndexOf('.') + 1)
      .toLowerCase();
    if (['png', 'jpeg', 'jpg', 'bmp'].includes(fileExtension)) {
      const maxSize = 10240 * 1024;
      if (file.size > maxSize) {
        Toast.show('图片大小不能超过10M~');
        return false;
      }
      return true;
    } else {
      Toast.show('暂不支持该文件格式');
      return false;
    }
  };

  const changeUrl = async (event: ChangeEvent) => {
    const el = event.target as HTMLInputElement;
    // 限制图片上传类型
    const files = [...((el && el.files) || [])];
    console.log('上传的文件：', files);
    setLoading(true);
    try {
      const res = (await Promise.all(
        files.map((file: File) => {
          return new Promise(async (resolve, reject) => {
            if (beforeUploadImgTypeLimit(file)) {
              ossUploadFile(file)
                .then(updateRet => {
                  const protocol = updateRet.useHttpForAccessLink
                    ? 'https://'
                    : 'http://';
                  const filePath =
                    protocol +
                    updateRet.domain +
                    '/' +
                    updateRet.filePath +
                    '/' +
                    updateRet.fileName;
                  console.log('filePath', filePath);
                  resolve({
                    fileName: updateRet.fileName,
                    fileOssPath: updateRet.filePath,
                    url: filePath
                  });
                })
                .catch(error => {
                  reject(error);
                });
            } else {
              reject(false);
            }
          });
        })
      )) as FileDto[];

      onChange([...values, ...res]);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };
  const handleClick = () => {
    console.log('handleClick', inputEl.current);
    inputEl.current && inputEl.current.click();
  };

  const handeClickRemove = (index: number) => {
    onChange(values.filter((item, i) => i !== index));
  };

  useEffect(() => {
    if (loading) {
      FullLoading.show({
        text: '上传中'
      });
    } else {
      FullLoading.hide();
    }
  }, [loading]);

  return (
    <div>
      <input
        ref={inputEl}
        accept="image/jpeg,image/jpg,image/png"
        style={{ display: 'none' }}
        type="file"
        multiple
        onChange={changeUrl}
        // 及时置空 避免在连续上传同一个文件时 onChange事件不被触发
        onClick={(event: any) => {
          if (event.target) {
            event.target.value = null;
          }
        }}
      />
      <PhotoProvider>
        <div className="img-list">
          {values.map((item, index) => (
            <div key={item.url} className="img-wrap">
              <div onClick={() => handeClickRemove(index)} className="delete">
                ×
              </div>
              <PhotoView src={item.url}>
                <img className="img" src={item.url} alt="" />
              </PhotoView>
            </div>
          ))}
          <button onClick={handleClick} className="add">
            +
          </button>
        </div>
      </PhotoProvider>
    </div>
  );
};
